import React, { useState, useEffect, useRef } from 'react';
import CustomSelectButton from './CustomSelectButton';
import CustomSelect_Bus from './CustomSelect_Bus';
import * as $ from 'jquery';
import moment from 'moment';
import styles from './Filter_Bus.module.css';
import { useMultivarientVehicleData } from '../context';

export default function GlobalFilter({ autoScrollToChartDiv }) {
    const { GlobalData, setGlobalData } = useMultivarientVehicleData()
    const [selectedField, setSelectedField] = useState("VIN_NUM");
    const [clearFilters, setClearFilter] = useState(true);
    const inputRef = useRef(null);
    const [localData, setLocalData] = useState({
        "startDate": moment().subtract(7, 'days').format("YYYY-MM-DD"),
        "endDate": moment().subtract(1, 'days').format("YYYY-MM-DD"),
        VIN_NUM: [],
        REG_NUM: [],
        CITY: []
    })

    useEffect(() => {
        if (localData?.startDate) {
            const today = moment();
            const fiveYearsAgo = moment().subtract(5, 'years');
            const defaultStart = moment(localData.startDate);
            const defaultEnd = moment(localData.endDate);

            $(inputRef.current).daterangepicker({
                startDate: defaultStart,
                endDate: defaultEnd,
                minDate: fiveYearsAgo,
                maxDate: today,
                showDropdowns: true,
                autoUpdateInput: false,
                singleMonthMode: true,
                linkedCalendars: false,
                locale: {
                    format: 'MMMM D, YYYY',
                    applyLabel: 'Apply',
                    separator: ' - ',
                    cancelLabel: '',
                },
            });

            $(inputRef.current).on('show.daterangepicker', function (ev, picker) {
                picker.container.addClass('ms_ace');
            });

            $(inputRef.current).on('apply.daterangepicker', function (ev, picker) {
                const start = picker.startDate.format("YYYY-MM-DD");
                const end = picker.endDate.format("YYYY-MM-DD");

                $(this).val(
                    picker.startDate.format('MMMM D, YYYY') + ' - ' + picker.endDate.format('MMMM D, YYYY')
                );

                setLocalData(prev => ({
                    ...prev,
                    startDate: start,
                    endDate: end,
                }));
            });

            $(inputRef.current).on('cancel.daterangepicker', function () {
                $(this).val('');
                setLocalData(prev => ({
                    ...prev,
                    startDate: null,
                    endDate: null,
                }));
            });
        }

        return () => {
            if ($(inputRef.current).data('daterangepicker')) {
                $(inputRef.current).data('daterangepicker').remove();
                $(inputRef.current).off('.daterangepicker');
            }
        };
    }, [GlobalData]);

    const selectedFunction = (value) => {
        setSelectedField(value)
        setLocalData(prev => ({ ...prev, VIN_NUM: [], REG_NUM: [] }))
    }

    const ApplyFilterFunction = () => {

        setGlobalData(prev => ({
            ...prev,
            startDate: localData.startDate,
            endDate: localData.endDate,
            VIN_NUM: selectedField === "VIN_NUM" ? localData.VIN_NUM : [],
            REG_NUM: selectedField === "REG_NUM" ? localData.REG_NUM : [],
            CITY: localData.CITY
        }));
        autoScrollToChartDiv()
    };

    const clearFilter = () => {
        setClearFilter(!clearFilters);
        setGlobalData(prev => ({
            ...prev,
            startDate: moment().subtract(7, 'days').format("YYYY-MM-DD"),
            endDate: moment().subtract(1, 'days').format("YYYY-MM-DD"),
            VIN_NUM: [],
            REG_NUM: [],
            CITY: []
        }));

        setLocalData(prev => ({
            ...prev,
            startDate: moment().subtract(7, 'days').format("YYYY-MM-DD"),
            endDate: moment().subtract(1, 'days').format("YYYY-MM-DD"),
            VIN_NUM: [],
            REG_NUM: [],
            CITY: []
        }))
    };

    const formatDateForDisplay = (date) => date ? moment(date).format('MMM D, YYYY') : '';

    const clearSelectedVinAndReg = (arr) => {
        setLocalData(prev => ({ ...prev, VIN_NUM: [], REG_NUM: [] }))
    }

    return (
        <div className={`card mb-3 p-3 ${styles.filter_card}`}>
            <div className={styles.filter_row}>

                {/* City */}
                {/* <div className={styles.filter_item}>
                    <CustomSelect_Bus
                        clearSelectedVinAndReg={clearSelectedVinAndReg}
                        clearFilters={clearFilters}
                        localData={localData}
                        setLocalData={setLocalData}
                    />
                </div> */}

                {/* VIN / REG */}
                <div className={styles.filter_item}>
                    <div className={styles.filter_label}>{selectedField === "VIN_NUM" ? "VIN No." : "Reg. No."}</div>
                    <div className={styles.vin_reg_row}>
                        <select className={styles.filter_dropdown_small} value={selectedField} onChange={(e) => selectedFunction(e.target.value)}>
                            <option value="VIN_NUM">VIN</option>
                            <option value="REG_NUM">Reg.</option>
                        </select>
                        <div className={styles.filter_dropdown_container}>
                            {selectedField === "VIN_NUM"
                                ? <CustomSelectButton
                                    apiEnd="vin"
                                    updateFilter={(arr) => setLocalData(prev => ({ ...prev, VIN_NUM: [arr?.value] }))}
                                    className={styles.filter_dropdown}
                                    localData={localData}
                                />
                                : <CustomSelectButton
                                    apiEnd="reg"
                                    updateFilter={(arr) => setLocalData(prev => ({ ...prev, REG_NUM: [arr?.value] }))}
                                    className={styles.filter_dropdown}
                                    localData={localData}
                                />
                            }
                        </div>
                    </div>
                </div>

                {/* Date Picker */}
                <div className={styles.filter_item}>
                    <div className={styles.filter_label}>Date Range</div>
                    <input
                        type="text"
                        ref={inputRef}
                        className={`${styles.filter_dropdown} ${styles.customDateRangePicker}`}
                        placeholder="Select date range"
                        value={
                            localData.startDate && localData.endDate
                                ? `${formatDateForDisplay(localData.startDate)} - ${formatDateForDisplay(localData.endDate)}`
                                : ''
                        }
                        readOnly
                    />
                </div>

                {/* Buttons */}
                <div className={styles.filter_buttons}>
                    <button className="btn btn-sm ms_btn_ace me-2 active" onClick={ApplyFilterFunction}>Apply</button>
                    <button className="btn btn-sm ms_btn_ace me-2" onClick={clearFilter}>Clear</button>
                </div>

            </div>
        </div>
    );
}
